export default __webpack_public_path__ + "static/media/opened-enabled.494c013f.svg";